<template>
<div class="card mt-4 pt-3 px-3 h-100 full-page-card">
  <h2 class="card-title">{{leadType}} Overview</h2>
  <div class="full-page-card__content d-flex flex-column">
    <!-- Start Three panel -->
    <!-- <div class="row" style="height:4rem;">
      <div class="col-2 h-100">
        
      </div>
        <div class="col-3 h-100">
        Search
      </div>
        <div class="col-7 h-100">
      
      </div>
    </div> -->
      <div class="row" style="flex-grow:1; overflow:hidden">
      <!-- <div class="col-2 h-100 bg-warning">
        Tags
      </div> -->
      <!-- Branches and Leads -->
      <div class="col-3 leads h-100 scrollable">
        <div class="lead__container" v-for="lead in leads" :key="'lead-' + lead.id">
          <div class="lead" :class="selectedLead && selectedLead.id === lead.id ? 'active' : null" @click="selectLead(lead)">
            <div class="lead-info">
              <LocationIcon :logo="lead.logoUrl"></LocationIcon>
              <p class="description">
                {{ lead.name }}
              </p>
            </div>
          </div>
          <div class="branches" v-if="selectedLead && selectedLead.id === lead.id">
            <div class="branch" :class="selectedBranch && selectedBranch.id === branch.id ? 'active' : null" v-for="branch in branches" :key="'branch-' + branch.id" @click="selectBranch(branch)">
              <p class="description">
                <strong>{{ branch.name }}</strong><br>
                {{ branch.address_line_1 }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <!-- End Branches and Leads -->


      <!-- 
        
        Lead Details 
        --------------------
        
      -->
      <div class="col-9 h-100 scrollable" v-if="selectedLead && !selectedBranch && leadStats">
        <div class="row  pt-4" style="position: sticky; top: 0; z-index: 1; background: white;">
          <!--  -->
          <div class="col-6">
            <stats-card title="Total Drops"
                        icon="fa fa-parachute-box"
                        :subTitle="''+leadStats.totalDrops"
                        ></stats-card>
          </div>
          <!--  -->
          <div class="col-6">
            <stats-card title="Total Issues"
                        icon="fa fa-exclamation-triangle"
                        :subTitle="''+leadStats.totalIssues"
                        ></stats-card>
          </div>
        </div>
        <div class="row">
            <!--  -->
            <div class="col-12 mt-2" v-if="leadStats">
              <h2>Connected {{ oppositeLeadTypePlural }}</h2>

              <el-table class="table-responsive table-flush"
                        header-row-class-name="thead-light"
                        :data="leadStats.relatedBranches">
                <el-table-column label="Branch"
                            min-width="150px"
                            prop="branch"
                            >
                  <template v-slot="{row}">
                    <LocationIcon avatarSize="sm" :name="row.name" :logo="row.logoUrl"></LocationIcon>                          
                  </template>
                </el-table-column>
                <el-table-column label="Drops"
                            prop="drop"
                            >
                  <template v-slot="{row}">
                    <div class="col-3 text-center">{{row.dropCount}}</div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <!--  -->
            <div class="col-12 mt-5" v-if="leadStats">
              <h2>Drops by Branch</h2>

              <el-table class="table-responsive table-flush"
                        header-row-class-name="thead-light"
                        :data="leadStats.myBranches">
                <el-table-column label="Branch"
                            min-width="170px"
                            prop="branch"
                            >
                  <template v-slot="{row}">
                    <LocationIcon avatarSize="sm" :name="row.name" :logo="row.logoUrl"></LocationIcon>                          
                  </template>
                </el-table-column>
                <el-table-column label="Drops"
                            
                            prop="drop"
                            >
                  <template v-slot="{row}">
                    <div class="col-3 text-center">{{row.dropCount}}</div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          
          </div>
        </div>

      <!-- 
        
        Branch Details 
        --------------------
        
      -->
      <div class="col-9 h-100 scrollable" v-if="selectedBranch && branchStats">
        <div class="row pt-4" style="position: sticky; top: 0; z-index: 1; background: white;">
          <!--  -->
          <div class="col-6">
            <stats-card title="Total Drops"
                        icon="fa fa-parachute-box"
                        :subTitle="''+branchStats.totalDrops"
                        ></stats-card>
          </div>
          <!--  -->
          <div class="col-6">
            <stats-card title="Total Issues"
                        icon="fa fa-exclamation-triangle"
                        :subTitle="''+branchStats.totalIssues"
                        ></stats-card>
          </div>
        </div>
        <div class="row">
            <!--  -->
            <div class="col-12 mt-2" v-if="branchStats">
              <h2>Connected {{ oppositeLeadTypePlural }}</h2>

              <el-table class="table-responsive table-flush"
                        header-row-class-name="thead-light"
                        :data="branchStats.relatedBranches">
                <el-table-column label="Branch"
                            min-width="150px"
                            prop="branch"
                            >
                  <template v-slot="{row}">
                    <LocationIcon avatarSize="sm" :name="row.name" :logo="row.logoUrl"></LocationIcon>                          
                  </template>
                </el-table-column>
                <el-table-column label="Drops"
                            prop="drop"
                            >
                  <template v-slot="{row}">
                    <div class="col-3 text-center">{{row.dropCount}}</div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <!--  -->
            <div class="col-12 mt-5" v-if="branchStats">
              <h2>Recent Drops</h2>

              <el-table class="table-responsive table-flush"
                        header-row-class-name="thead-light"
                        :data="branchStats.drops">
                <el-table-column :label="oppositeLeadType"
                            min-width="170px"
                            prop="branch"
                            >
                  <template v-slot="{row}">
                    <LocationIcon avatarSize="sm" :name="leadType==='Retailer'?row.charity.name:row.retailer.name" :logo="leadType==='Retailer'?row.charity.logoUrl:row.retailer.logoUrl"></LocationIcon>                          
                  </template>
                </el-table-column>
                <el-table-column label="User"
                            min-width="170px"
                            prop="branch"
                            >
                  <template v-slot="{row}">
                    <UserIcon avatarSize="sm" 
                              :firstName="row.volunteer.firstName" 
                              :lastName="row.volunteer.lastName" 
                              :userId="row.volunteer.id"></UserIcon>                          
                  </template>
                </el-table-column>
                <el-table-column label="Status"
                            min-width="170px"
                            prop="drop"
                            >
                  <template v-slot="{row}">
                    <badge class="badge-dot badge-xl mr-4" type="">
                      <i :class="`bg-${getDropStatus(row).color}`"></i>&nbsp;
                      <span class="status">{{ getDropStatus(row).message}}</span>
                  </badge>
                  </template>
                </el-table-column>
              </el-table>
          </div>
        </div>
      </div>
        
    </div>
  </div>
  <!-- End three panel -->

</div>
</template>
<script>

  import LocationIcon from '../LocationIcon';
  import UserIcon from '../UserIcon';
  import { Table, TableColumn, DropdownMenu, DropdownItem, Dropdown} from 'element-ui';

  export default {
    name: 'overview-card',
    components: {
      LocationIcon,
      UserIcon,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      [Dropdown.name]: Dropdown,
      [DropdownItem.name]: DropdownItem,
      [DropdownMenu.name]: DropdownMenu,
    },

    created() {
      
    },

    props:[
        'leads',
        'branches',
        'drops',
        'selectedLead',
        'selectedBranch',
        'leadStats',
        'branchStats',
        'leadType',
        'leadTypePlural',
        'oppositeLeadType',
        'oppositeLeadTypePlural',
    ],

    data() {
       return {
        
      };
    },

    methods:{
      /**
       * @param {object} lead 
       */
      selectLead(lead) {
        this.$emit('leadSelected',lead);        
      },

      /**
       * @param {object} branch 
       */
      selectBranch(branch) {
        this.$emit('branchSelected',branch);
      },

      /**
       * @param {object} drop A drop
       */
      getDropStatus(drop){
        if(drop.cancelledReason){
          return {color:'danger', message:drop.cancelledReason};
        }
        else if(drop.hasIssue){
          return {color:'danger', message:'Issue Reported'};
        }
        else if(drop.dropComplete){
          return {color:'success', message:'Completed'};
        }
        else if(drop.started){
          return {color:'info', message:'In Progress'};
        }
        return {color:'info', message:'Booked'};
      }
    }
  }
</script>

<style lang="scss" scoped>

  .lead {
    padding: 1.25rem;
    transition: background-color 250ms ease;
    border-bottom: 1px solid #E5EAF3;
    cursor: pointer;

    &.active {
      background-color: #EFF0F6;
      border-left: 0.375rem solid #F95940;
      padding-left: (1.25rem - 0.375rem);
    }

    .lead-info {
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      align-items: center;
      justify-items: center;
    
      .logo {
        width: 2.8125rem;
        border-radius: 50%;
        margin-right: 0.75rem;
      }

      .description {
        margin: 0;
        padding: 0;
        font-size: 0.9573rem;
        line-height: 1.125rem;
      }
    }
  }

  .branches {
    .branch {
      padding: 0.75rem;

      &.active {
        background-color: #F9F9F9;
        border-right: 0.375rem solid #F95940;
        padding-right: (0.75rem - 0.375rem);
      }
      
      .description {
        margin: 0;
        padding: 0;
        font-size: 0.9573rem;
        line-height: 1.125rem;
        text-align: right;
      }
    }
  }
  
</style>
